import React, { useEffect, useState, useLayoutEffect } from "react";
import PageTitle from "../banner";

function Contact() {
  const getInitialBgImage = () =>
    window.innerWidth <= 768
      ? "img/about/contactmb.jpg"
      : "img/about/banner06.jpg";
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [bgImage, setBgImage] = useState(getInitialBgImage);

  useLayoutEffect(() => {
    const handleResize = () => {
      setBgImage(
        window.innerWidth <= 768
          ? "img/about/contactmb.jpg"
          : "img/about/banner06.jpg"
      );
      setIsMobile(window.innerWidth <= 768);
    };

    const debounceResize = debounce(handleResize, 100);

    window.addEventListener("resize", debounceResize);
    return () => {
      window.removeEventListener("resize", debounceResize);
    };
  }, []);

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  return (
    <div>
      <div style={{ marginBottom: "5rem" }}>
        <PageTitle desc={"Contact"} img={bgImage} />
      </div>
      <section class="contact-section" style={{ paddingBottom: "100px" }}>
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-6">
              <div class="contact-text">
                <h3>Get in touch</h3>
                <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                  <img
                    src={`img/hero/nagesh.jpeg`}
                    style={{
                      flexShrink: 0,
                      maxWidth: "100%",
                      height: "300px",
                      borderRadius: "12px",
                    }}
                  />
                </div>
                <p>
                  I am excited to connect with you! Whether you have a question
                  or you want to have a print of any of these photographs feel
                  free to reach out to me....
                </p>

                <div class="ct-item">
                  <div class="ct-icon">
                    <i class="fa fa-mobile"></i>
                  </div>
                  <div class="ct-text">
                    <h5>Phone</h5>
                    <ul>
                      <li>+91 9880188455</li>
                    </ul>
                  </div>
                </div>
                <div class="ct-item">
                  <div class="ct-icon">
                    <i class="fa fa-envelope"></i>
                  </div>
                  <div class="ct-text">
                    <h5>Email</h5>
                    <p>rohinag2@gmail.com</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6">
              <div class="contact-form">
                <h3>We‘d love to hear from you</h3>
                <form action="#">
                  <input type="text" placeholder="Name" />
                  <input type="text" placeholder="Email" />
                  <input type="text" placeholder="Website" />
                  <textarea placeholder="Message"></textarea>
                  <button type="submit" class="site-btn">
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
